import { useCurrentLocaleSelector as getCurrentLocaleSelector } from './localisation';
import axios from "axios";
import { getBearerToken } from "../auth";
import { refreshUserAccessToken } from './kintopiaApi';
import { getCurrentUserEmail } from './apis';

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "X-Kinship-Source": "THE_WILDEST_ADMIN",
    'Accept-Language': getCurrentLocaleSelector(),
    "X-KI-Requester-Email": getCurrentUserEmail()
  },
  mode: "no-cors",
  crossdomain: true,
  // baseURL: API_URL,
  baseURL: process.env.REACT_APP_KINTOPIA_API_BASE_PATH,
});

axiosInstance.interceptors.request.use(async (config) => {
  if (config.url === 'auth/v2-sign-in') {
    return config;
  }
  const token = await getBearerToken();
  config.headers.common["Authorization"] = `Bearer ${token}`;
  return config;
});

axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    if (error.response.data.status === 403) {
      await refreshUserAccessToken();
    }
    return Promise.reject(error);
  }
);

// consider renaming to authedAxiosInstace or something later on.
export default axiosInstance;
